<terra-dialog-header>
  <h1>Import your contacts</h1>
  <a href="https://help.covercy.com/how-to-import-contacts-and-investing-entities" target="_blank">Learn more...</a>
</terra-dialog-header>

<ng-template #loader>
  <terra-loader class="dialog-loader" />
</ng-template>

<mat-dialog-content *ngIf="!(isLoading$ | async); else loader">
  <div class="pb-2">
    <div class="cov-form-grid">
      <div class="full-width">
        <ol class="instructions-list">
          <li>
            <a (click)="downloadTemplate()" class="example-file-link light link">
              Download contacts import template</a> (if you haven't already)
          </li>
          <li>
            Add contacts details, and their investing entities (optional)
          </li>
          <li>Upload the updated file using the button below, and click "Import"</li>
        </ol>
        <terra-file-import-upload 
        [uploadEndpoint]="uploadEndpoint$ | async" 
        [submitImport]="submitImport$"
        (onError)="onErrorImport($event)"
        (onSuccess)="onSuccessImport($event)"
        (disableSubmitted)="disableSubmitted.set($event)"
        (isProcessing)="isProcessing$.next($event)"></terra-file-import-upload>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button type="submit" [disabled]="(isProcessing$ | async) || disableSubmitted()" (click)="import()" class="page-cta" color="primary" mat-flat-button>
    <span>Import</span>
    <terra-loader *ngIf="isProcessing$ | async" />
  </button>
  <button [disabled]="isProcessing$ | async" type="button" mat-button class="cancel-button tall-button" [mat-dialog-close]="undefined">
    Cancel
  </button>
</mat-dialog-actions>


